import { useTranslation } from 'react-i18next';

import InfoBox from 'app/components/InfoBox';
import { SubjectType } from 'app/containers/AWPM-FWPM/ModuleSelections/models';
import { translations } from 'locales/i18n';

export const SelectionInfoBox = ({ subjectType }) => {
  const { t } = useTranslation();
  return (
    <InfoBox expandable collapsed title={t(translations.pages.studentView.note())} type="info">
      <div>
        {t(translations.pages.studentView.infoBoxModuleSelection())}
        {subjectType === SubjectType.Awpm
          ? t(translations.pages.studentView.infoBoxModuleSelectionAWPM())
          : null}
      </div>
    </InfoBox>
  );
};
